/** The Commander apps an admin can log into on behalf of a user. */
export const COMMANDER_URL = "https://commander.triangula.com";
export const ADMIN_COMMANDER_URL = "https://admin.triangula.com";
export const REPLAY_URL = "https://replay.triangula.com";
